import { useRef } from "react";
import SectionTitle from "./SectionTitle";
import { useGsapAboutTextReveal } from "../hooks/gsap";

const About = ({ minHeight }) => {
  const aboutRef = useRef(null);
  const aboutTextRef = useRef([]);

  aboutTextRef.current = [];

  const addToRefs = (el) => {
    if (el && !aboutTextRef.current.includes(el)) {
      aboutTextRef.current.push(el);
    }
  };

  useGsapAboutTextReveal(aboutTextRef.current, aboutRef);

  const text1 =
    "Explore the lost treasures and shining stars of the 1990s! Find your favorite cartoons, TV shows, music albums, & more with easy filtering functionality. With Immemorial, stay up-to-date with all your 90s favorites while turning back time.";

  const text2 =
    "What's the only era that never seems to end? The 90s! Journey through appreciating items from 90s TV, music, and art. See if you remember old toys, cartoons, or prints of such. Indulge in some nostalgia before our world falls back into the dark ages.";

  return (
    <section
      className="about wrapper"
      style={minHeight ? { minHeight: "100vh" } : null}
      ref={aboutRef}
    >
      <SectionTitle title="About" />
      <p className="about-text-reveal">
        {text1.split("").map((char, index) => (
          <span key={index} ref={addToRefs}>
            {char}
          </span>
        ))}
      </p>
      <p className="about-text-reveal">
        {text2.split("").map((char, index) => (
          <span key={index} ref={addToRefs}>
            {char}
          </span>
        ))}
      </p>
    </section>
  );
};

export default About;
